import {
  getArrivalColor,
  getGateColour,
  getOrdinalSuffix,
  shortenName,
} from "../../../utils/helper-funcs";
import { CompetitorData } from "../DataProvider";
import { getFlag } from "../../../images/flags/getFlag";

interface podiumCardProps {
  competitor: CompetitorData | null;
  compact?: boolean;
}

export function PodiumCard({ competitor, compact = false }: podiumCardProps) {
  if (!competitor) return <div className="w-1/3 h-full bg-slate-700"></div>;
  return (
    <li
      className={`flex flex-col items-center w-1/3 h-full ${
        competitor.arrival === 1 ? "justify-start" : "justify-end"
      }`}
    >
      <div className={`flex justify-between items-center w-full ${
        compact ? 'py-2 px-3' : 'py-6 px-[34px]'
      }`}>
        <div className="flex items-start justify-center italic font-extrabold">
          <span className={compact ? 'text-3xl' : 'text-[64px]'}>
            {competitor.arrival}
          </span>
          <span className={compact ? 'text-xl' : 'text-5xl'}>
            {getOrdinalSuffix(competitor.arrival)}
          </span>
        </div>
        <div className={compact ? 'w-8 h-8' : 'w-20 h-20'}>
          <img
            src={getFlag(competitor.name)}
            alt=""
            className="object-contain w-full h-full"
          />
        </div>
      </div>

      <div
        className={`flex items-center justify-between w-full ${
          compact ? 'px-2 py-1 border-b-4' : 'px-6 py-4 border-b-8'
        }`}
        style={{
          color: getArrivalColor(competitor.arrival),
          borderColor: getGateColour(competitor.cardinal),
        }}
      >
        <span className={compact ? 'text-xs italic truncate max-w-[90px]' : 'text-2xl italic'}>
          {shortenName(competitor.name)}
        </span>
        {/* <span className={compact ? 'text-xs italic font-extrabold' : 'text-2xl italic font-extrabold'}>
          {competitor.oddsWin.toFixed(2)}
        </span> */}
      </div>
    </li>
  );
}